/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInterestSettingsRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetInterestSettingsResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getInterestSettingsAppAction = (request: GetInterestSettingsRequest, options?: CashRequestOptions) => post<GetInterestSettingsRequest, GetInterestSettingsResponse>("/2.0/cash/get-interest-settings-app-action", request, {...options, rejectOnError: true })